import React from "react";
import { Row, Col, Typography, List } from "antd";
import { template, resolveUrl, formatTime } from "@reco-m/core";
import { ViewComponent, Banner, ImageAuto, changePage } from "@reco-w/core-ui";
import { Namespaces, informationModel } from "@reco-w/information-models";
import { renderPagination } from "@reco-w/common-common";
import { BackTopBox } from "@reco-w/about-e";
const { Paragraph } = Typography;

export namespace Information {

    export interface IProps<S extends IState = IState> extends ViewComponent.IProps<S> { }

    export interface IState extends ViewComponent.IState, informationModel.StateType { }

    export class Component<P extends IProps = IProps, S extends IState = IState> extends ViewComponent.Base<P, S> {
        showloading = false;
        namespace = Namespaces.information;

        componentMount() {
            window.scroll(0, 0);
        }
        componentDidMount() {
            this.dispatch("input", { tabsIndex: 0 });
            this.dispatch("initPage", { pageIndex: this.getSearchParam('pi') || 1, pageSize: this.getSearchParam('ps') || 6, tagId: this.getSearchParam('t') });
        }
        getData(tagId) {
            this.dispatch("getData", { inTagIds: tagId, pageIndex: this.getSearchParam('pi') || 1, pageSize: this.getSearchParam('ps') || 6 });
        }

        componentReceiveProps(nextProps: Readonly<P>) {
            let locationChanged = nextProps.location?.search !== this.props.location?.search || nextProps.location?.pathname !== this.props.location?.pathname;

            if (locationChanged) {
                setTimeout(() => {
                    const { state } = this.props,
                        tagId = state!.tagId;
                    this.getData(tagId);
                }, 20);
            }
        }

        renderBody() {
            const { state } = this.props,
                tabsIndex = state!.tabsIndex,
                items = state!.items,
                tagList = state!.tagList || [];

            return (
                <>
                    <div className="content">
                        <Banner.Component extraClass="large" bimg="assets/images/guanw/xwzx-banner.jpg" cimg="" text={
                            <div className="home-banner-text">
                                <div className="banner-text-name1">新闻中心</div>
                            </div>}
                        />
                        <div className="news-tabs">
                            <div className="container">
                                {
                                    tagList.map((item, i) => {
                                        return (
                                            <span className={tabsIndex === i ? "active" : ""} key={i} onClick={() => {
                                                this.dispatch("input", { tabsIndex: i, tagId: item.id });
                                                setTimeout(() => {
                                                    changePage(1, 6, this, item.tagName == "全部" ? { t: "", d: new Date().getTime() } : { t: item.id, d: new Date().getTime() })
                                                }, 0);
                                                // this.getData(item.id)
                                            }}>{item.tagName}</span>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className="container">
                            <List
                                className="news-list mt30"
                                itemLayout="vertical"
                                bordered={false}
                                style={{ marginTop: items?.length ? '0' : '100px' }}
                                size="large"
                                dataSource={items}
                                renderItem={(item: any, i) => {
                                    return (
                                        // <router.Link target="_blank" to={`/information/details/${item.id}`}>
                                        <List.Item key={i} style={{ cursor: 'pointer' }} onClick={() => {
                                            if (item.contentType == 1) {
                                                this.goTo(`/information/details/${item.id}`);
                                            } else if (item.contentType == 2) {
                                                window.open(item.content)
                                            }
                                        }}>
                                            <Row gutter={35}>
                                                <Col xs={24} sm={24} md={7}>
                                                    <ImageAuto.Component src={resolveUrl(item.logo)} width="100%" height="200px" radius={0} />
                                                </Col>
                                                <Col xs={24} sm={24} md={17}>
                                                    <Paragraph ellipsis={{ rows: 1, expandable: false }} className="size-20 mt5 mb0 news-list-title">
                                                        {item.title}
                                                    </Paragraph>
                                                    {!!item.summary && <Paragraph ellipsis={{ rows: 3, expandable: false }} className="size-17 gray-three-color mb0 mt15">
                                                        {item.summary}
                                                    </Paragraph>}
                                                    <Row justify="space-between" align="middle" className="mt25">
                                                        <div>
                                                            {(item.tagNames || ',').split(',').map((x, j) =>
                                                                x.indexOf("资讯-") === -1 ? <span key={j}></span> :
                                                                    <span className="custom-tag type1 margin-right-xs" key={j}>{x.replace("资讯-", '')}</span>
                                                            )}
                                                        </div>
                                                        <div className="size-16 gray-one-color"><i className="icon icon-shijian mr3 gray-one-color" />{formatTime(item.publishTime, 'yyyy.MM.dd')}</div>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </List.Item>
                                        // </router.Link>
                                    );
                                }
                                }
                            />
                            <div className="paging" style={{ marginTop: '50px' }}>
                                {renderPagination(this)}
                                {/* <Pagination
                                    showSizeChanger={true} // 是否可以改变 pageSize
                                    showQuickJumper={true} // 是否可以快速跳转至某页
                                    current={1} // 默认的页码
                                    pageSizeOptions={["4", "6", "8", "12", "16", "20", "24"]}
                                    total={50} // 数据总数
                                /> */}
                            </div>
                        </div>
                    </div >

                    {this.renderEmbeddedView(BackTopBox.Page)}
                    {/*<div className="scoll-top">
                        <BackTop visibilityHeight={50} />
                    </div>*/}
                </>
            );
        }
    }

    export const Page = template(Component, (state) => state[Namespaces.information]);
}
